// JsFromRoutes CacheKey d725e24493285d094e4dbb6b4ce14c1c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/members/continuation_of_coverage'),
  accept: /* #__PURE__ */ definePathHelper('post', '/members/continuation_of_coverage/accept'),
  cobraElectionNotice: /* #__PURE__ */ definePathHelper('get', '/members/continuation_of_coverage/cobra_election_notice'),
  decline: /* #__PURE__ */ definePathHelper('post', '/members/continuation_of_coverage/decline'),
  faq: /* #__PURE__ */ definePathHelper('get', '/members/continuation_of_coverage/faq'),
}
